import { createSlice } from "@reduxjs/toolkit";
import { VaccinationService, VaccinationData } from "api/eventpass/services/VaccinationService";
import { EventPass } from "api/eventpass/types";
import { getEventPassData } from "appredux/actions/showActions";

interface EventPassState {
  data: EventPass;
  horsesVaccinationData: Record<string, VaccinationData>;
  loading: "pending" | "succeeded" | "failed";
}

const initialState = {
  data: null,
  horsesVaccinationData: null,
  loading: "pending",
} satisfies EventPassState as EventPassState;

const eventPassSlice = createSlice({
  name: "eventPass",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEventPassData.fulfilled, (state, action) => {
      state.data = action.payload as EventPass;
      state.loading = "succeeded";
    });

    builder.addCase(getEventPassData.pending, (state, action) => {
      state.loading = "pending";
    });

    builder.addCase(getEventPassData.rejected, (state, action) => {
      state.loading = "failed";
    });
  },
  selectors: {
    selectEventPass: (sliceState) => sliceState.data,
    selectHorsesVaccinationData: (sliceState) => sliceState.horsesVaccinationData,
    selectLoading: (sliceState) => sliceState.loading,
  },
});

export const { selectEventPass, selectHorsesVaccinationData, selectLoading } =
  eventPassSlice.selectors;

export default eventPassSlice.reducer;
